<app-header></app-header>

<div class="page-title-area newsBg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Acasa</a></li>
                <li>Cariere</li>
            </ul>
            <h2>Cariere</h2>
        </div>
    </div>
</div>
<section class="bg my-5">
    <div class="container">
        <div class="row" *ngFor="let career of careers">

            <a class="col-lg-8 newsItem offset-lg-2" routerLink="/cariere/cariera/{{career.id}}">
                <div class="img">
                    <div *ngIf="career.photo"><img [src]="setFilePath(career)" alt="test"></div>
                    <div *ngIf="!career.photo"><img src="../../../assets/img/placeImg.jpg" alt=""></div>
                </div>
                <div class="content">
                    <h3>{{career.title}}</h3>
                    <p>{{career.abstract}}</p>
                </div>
                <div class="date">
                    {{career.date | date:'dd/MM/yyyy'}}
                </div>
            </a>

        </div>
    </div>
</section>
